/**
 * One-click local and PTR QA surface for Mobile Touch testing.
 *
 * `/mobile` boots first_field in the clean live-lobby preset with touch
 * controls enabled, dev class abilities, noclip for easy map traversal,
 * and splash/login skipped.
 */
import type { ModeUrlConfig } from '../boot/coerceModeUrl';

export const MOBILE_QA_ROUTE = '/mobile' as const;

export const MOBILE_QA_CONFIG: ModeUrlConfig = {
  resetOnLoad: true,
  preset: 'live-lobby',
  skipSplash: true,
  skipLogin: true,
  autoClass: 'dev',
  touchControls: true,
  noclip: true,
  testhooks: true,
};

export const MOBILE_QA_MAP_ID = 'first_field';
